import { createRoot } from "react-dom/client";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import "./__product__/language/i18n";
import Provides from "./context/provides";
// eslint-disable-next-line import/extensions
import "./global.d.ts";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import App from "./App";
import { ArrowUpSvg } from "./components/atom/arrow_up/ArrowUpSvg";
import { GoogleAnalytics } from "./components/experience/googleTagManager/googleTagManager";
import { ToastContainer } from "react-toastify";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <BrowserRouter>
    <ToastContainer />
    <Provides>
      {process.env.REACT_APP_ENV === "prod" && <GoogleAnalytics />}
      <App />
      <ScrollToTop className={"scroll-to-top"} smooth component={<ArrowUpSvg />} />
    </Provides>
  </BrowserRouter>
);

reportWebVitals();
